import { CellValue, ColumnType, ITypeOptions, NumberFormat } from '../../types';
import { transformNumberToRating } from '../transformNumber';
import { transformCellValueToNumber } from './transformCellValueToNumber';

export const transformCellValueToRating = <OT extends ColumnType>({
  originCellValue,
  originTypeOptions,
  targetTypeOptions,
}: {
  originCellValue: CellValue<OT>;
  originTypeOptions: ITypeOptions<OT>;
  targetTypeOptions: Pick<ITypeOptions<ColumnType.RATING>, 'ratingMax'>;
}): number | null => {

  const numberValue = transformCellValueToNumber({
    originCellValue,
    originTypeOptions,
    targetTypeOptions: {
      numberFormat: NumberFormat.DECIMAL,
    },
  });

  if (numberValue === null) return null;

  return transformNumberToRating({
    numberValue: numberValue,
    ratingMax: targetTypeOptions.ratingMax,
  });
};
